













import Vue from 'vue';
import Component from 'vue-class-component';
import { PageTitle } from '@questelservices/common-vue';
import CommentsGrid from '../components/activity-planner/comments-grid.vue';
import { UserService } from '@/service/UserService';
import { UserSettingName } from '@/models/UserSetting';

@Component({
  components: {
    PageTitle,
    CommentsGrid
  }
})
export default class AllComments extends Vue {
  private userService: UserService;
  private respondToAgentValue: Guid = "";
  private forwardToClientValue: Guid = "";

  constructor() {
    super();
    this.userService = new UserService();
  }

  mounted() {
    this.userService.getCommentSettings().then(x=>{
      let respondToAgent = x.find(x=>x.Name == UserSettingName.RespondToAgent)
      this.respondToAgentValue = respondToAgent != null ? respondToAgent.Value : "";

      let forwardToClient = x.find(x=>x.Name == UserSettingName.ForwardToClient);
      this.forwardToClientValue = forwardToClient != null ? forwardToClient.Value: "";

      setTimeout(()=>{ }, 1000)
    })

    
  }
}
